import { useState, useCallback } from "react";

export const useClientPagination = ({
  initialPage = 0,
  initialPageSize = 5,
} = {}) => {
  const [page, setPage] = useState(initialPage);
  const [pageSize, setPageSize] = useState(initialPageSize);

  const handlePageChange = useCallback((_, newPage) => {
    setPage(newPage);
  }, []);

  const handlePageSizeChange = useCallback(
    (event) => {
      const value = parseInt(event.target.value, 10) || initialPageSize;
      setPageSize(value);
      setPage(0);
    },
    [initialPageSize]
  );

  const setPageToFirst = useCallback(() => {
    setPage(0);
  }, []);

  return {
    page,
    pageSize,
    handlePageChange,
    handlePageSizeChange,
    setPageToFirst,
  };
};
